import CustomerDetail1BackOriginScrollTopMixins from "@/mixins/CustomerDetail1BackOriginScrollTop";

export default {
    mixins: [CustomerDetail1BackOriginScrollTopMixins],
    props: [
        "policyType",
        "isLoading",
        "isAllLoading",
        "isPropertyLoading",
        "allFamilyDatas",
        "getCathayInsuranceResult",
        "getOtherInsuranceResult",
        "getGroupInsuranceResult",
        "cathayHealthInsurance",
        "cathayHurtInsurance",
        "cathayNewInsurance",
        "cathayCarInsurance",
        "cathayFireInsurance",
        "otherInsuranceNote",
        "otherNewInsurance",
        "otherCarInsurance",
        "otherFireInsurance",
    ],
    components: {
        CathayLifeInsurance: () =>
            import ("./components/CathayLifeInsurance"),
        CathayLifeInsuranceForEdit: () =>
            import ("./components/CathayLifeInsuranceForEdit"),
        OtherLifeInsurance: () =>
            import ("./components/OtherLifeInsurance"),
        OtherLifeInsuranceForEdit: () =>
            import ("./components/OtherLifeInsuranceForEdit"),
        ProductSuggest: () =>
            import ("./components/ProductSuggest"),
        ProductSuggestForEdit: () =>
            import ("./components/ProductSuggestForEdit"),
        CathayGroupInsurance: () =>
            import ("./components/CathayGroupInsurance"),
        PropertyInsurance: () =>
            import ("./components/PropertyInsurance"),
        OtherPropertyInsurance: () =>
            import ("./components/OtherPropertyInsurance"),
        Message: () =>
            import ("./components/Message")
    },
    methods: {
        panelOpen(name) {
            this[name] = true;
            document.querySelector('body').classList.add('modal-open');
          },
        panelClose(name) {
            return new Promise(resolve => {
                var open = document.querySelectorAll('.modal.is-open'),
                elem = open[open.length - 1];
                elem.className += ' is-out';
                elem.classList.remove('is-out');
                if (open.length >= 1) {
                document.querySelector('body').classList.remove('modal-open');
                }
                this[name] = false;
            });
        },
    },
    computed: {
        familyKeyBuCsidno() {
            return window._.keyBy(this.allFamilyDatas, "csidno");
        },
        lifeInsuranceList() {
            return [this.getCathayInsuranceResult]
                .concat(
                    this.getOtherInsuranceResult ? [
                        this.getOtherInsuranceResult.suggestinfo,
                        this.getOtherInsuranceResult.otherinfo
                    ] : []
                )
                .filter((x) => x);
        },
        groupInsuranceList() {
            return [this.getGroupInsuranceResult].filter((x) => x);
        },
        propertyInsuranceList() {
            return [
                    this.cathayHealthInsurance,
                    this.cathayHurtInsurance,
                    this.cathayNewInsurance,
                    this.cathayCarInsurance,
                    this.cathayFireInsurance,
                ]
                .map((x) => [].concat(x.policies ? x.policies : [], x.policiesselfinput ? x.policiesselfinput : []))
                .concat(
                    [
                        this.otherInsuranceNote,
                        this.otherNewInsurance,
                        this.otherCarInsurance,
                        this.otherFireInsurance,
                    ]
                )
                .filter((x) => x);
        },
        allDataList() {
            return this.lifeInsuranceList.concat(
                this.groupInsuranceList,
                this.propertyInsuranceList
            );
        },
        isLifeInsuranceHasData() {
            return this.lifeInsuranceList.some((x) => x.length);
        },
        isGroupInsuranceHasData() {
            return this.groupInsuranceList.some((x) => x.length);
        },
        isPropertyInsuranceHasData() {
            return this.propertyInsuranceList.some((x) => x.length);
        },
        hasData() {
            return this.allDataList.some((x) => x.length);
        }
    }
};